import { SAMessageType } from "@missionlabs/smartagent-chat-components-lib/dist/ChatMessage/chat-message.types"

export interface IChatMessage {
    id: string;
    content: string | SAMessageType;
    originalMessage: string | undefined;
    isTranslated?: boolean;
    contentType: connect.ChatContentType;
    displayName: string;
    role: ParticipantRole;
    sentAt: string;
    sendStatus: ChatMessageSendStatus;
    isJson: boolean;
    type: connect.ChatTranscriptItem['Type'];
    attachments?: connect.AttachmentItem[];
    discarded?: boolean;
    deliveredTimestamp?: string;
    readTimestamp?: string;
    lastCustomerMessage?: boolean;
}

export type ChatMessageSendStatus = 'unknown' | 'success' | 'fail';

export enum ChatMessageEvent {
    TEXT = "text/plain",
    MARKDOWN = "text/markdown",
    TYPING = 'application/vnd.amazonaws.connect.event.typing',
    PARTICIPANT_JOINED = "application/vnd.amazonaws.connect.event.participant.joined",
    PARTICIPANT_LEFT = "application/vnd.amazonaws.connect.event.participant.left",
    CHAT_ENDED = "application/vnd.amazonaws.connect.event.chat.ended",
    // CHAT_STARTED = "application/vnd.amazonaws.connect.event.chat.started",
    TRANSFER_SUCCESS = "application/vnd.amazonaws.connect.event.transfer.succeeded",
    TRANSFER_FAILURE = "application/vnd.amazonaws.connect.event.transfer.failed",
    MESSAGE_DELIVERED = "application/vnd.amazonaws.connect.event.message.delivered",
    MESSAGE_READ = "application/vnd.amazonaws.connect.event.message.read",
}

export type ParticipantRole = "AGENT" | "CUSTOMER" | "SYSTEM";

type MessagesState = IChatMessage[]

export default MessagesState